import React from "react";

import Assistance from "../components/Home/Assistance";
import Hero from "../components/Home/Hero";
import Offer from "../components/Home/Offer";
import TradingDesk from "../components/Home/TradingDesk";

function Home() {
  return (
    <main className="flex flex-col gap-[80px] bg-white xl:gap-[160px]">
      <Hero />
      <TradingDesk />
      <Offer />
      <Assistance />
    </main>
  );
}

export default Home;
